import { pipe } from 'ramda';
import { addPagesId } from './addPagesId';
import { dropTempData } from './dropTempData';
import { introSpecifics } from './introSpecifics';
import { transformSurveyTextsToExpressions } from './textToExpressions';

export const surveyPostProcessing = pipe(dropTempData, introSpecifics, transformSurveyTextsToExpressions, addPagesId);
